<template>

  <div>
    <div v-for="book in propsdata" v-bind:key="book.id" class="bookCover">
                
          <img v-if="book.isActive"
              v-on:click="showMetheSpec(book)"
              class="bookImg"
              v-bind:src="require('@/assets/images_1/' + book.ISBN + '.jpg')"> 
<!--       

  v-bind:src="getImgURL(book)">
  -->

          <div v-else class="bookSpec">
            
            <div class="authorPart">
              <span class="factorStyle">저자</span>
              <span v-on:click="showBooksonKeywords(book.author)" class="contentsStyle author"> {{ book.author }} </span> 
            </div>
            
            <div class="contentsStyle synopsis"> {{ book.synopsis }} </div>

            <div>
              <span class="factorStyle">역자</span>
              <span v-on:click="showBooksonKeywords(book.translator)" class="contentsStyle translator"> {{ book.translator }} </span> 
            </div>

            <div>
              <span class="factorStyle">출판</span>
              <span v-on:click="showBooksonKeywords(book.publisher)" class="contentsStyle publisher">{{ book.publisher }} </span>
            </div>

            <div>
              <span class="factorStyle">출간</span>
              <span v-on:click="showBooksonKeywords(book.years)" class="contentsStyle years"> {{ book.years }}년 </span>
            </div>

            <div>
              <span v-on:click="showBooksonKeywords(book.fob)" class="contentsStyle fob"> {{ book.fob }} </span> 
              <span class="contentsStyle nob"> (총{{ book.nob }}권, </span>
              <span class="contentsStyle pages">{{ book.pages }}쪽) </span>
            </div>
<!--
            <div>
              <span class="factorStyle">ISBN</span>
              <span class="contentsStyle years"> {{ book.ISBN }} </span>
            </div>
    -->        

            <div class="buttons">
              <div v-on:click="reshowImg(book)" class="backToimg"> <i class="fas fa-times fa-2x"></i></div>
            </div>
        </div>

<!-- <i class="fas fa-times fa-2x"> -->

        <div class="keywordsUnderCover">
          <div v-on:click="showBooksonKeywords(book.title)" class="titlePart title"> {{ book.title }} </div> 

          <div class="keywordPart">
            <span class="tag"> <i class="fas fa-tags"></i> </span>
            <span v-on:click="showBooksonKeywords(keyword)" v-for="(keyword,i) in book.keywords" 
              v-bind:key="keyword+i" class="keywordBtn"> {{ keyword }} </span>
          </div>
        </div>    

    </div>
  </div>

</template>

 
<script>

export default {

  props: ['propsdata', 'genreActive', 'folderWithImage'],

  
  data: function() {

      return {

          clickedKeyword: ""
  
      }

  },

  
  methods: {

          getImgURL: function(book) {

            console.log("이미지 경로", book.imageURL);
            var url = 'require(' + book.imageURL +')';
            console.log("이미지 풀경로", url);
                        
            return url

          },

          showBooksonKeywords: function(word) {
              
              this.clickedKeyword = word;
              this.$emit('clickKeywordsOnlist', this.clickedKeyword);          

              // this.clickedKeyword = "";

          },

          showMetheSpec: function(book) {
          
            this.$emit('offImg', book);          

            console.log('여기는 리스트 컴포넌트! 지금 선택하신 아이디는',book.id,'입니다');
            console.log('표지가', book.isActive);
         
          },

          reshowImg: function(book) {

            this.$emit('onImg', book);

            console.log('표지가', book.isActive);
            console.log("나와라 표지!");

          }

      }

}

</script>

<style scoped>

* {

  box-sizing: border-box;

}

.tag {

  color: #4281ff;
}

.authorPart {
  box-sizing: border-box; 
  padding-top: 10px;
    
}


.factorStyle {

  font-size: 14px;
  font-style: normal;
  font-weight: bolder;
  color: #7987b4;
  margin-left:20px; 
  margin-right: 3px;

}

.contentsStyle {

  font-size: 14px;
  font-weight: bolder;
  font-style: normal;
  
}

.buttons {

  display: flex;
  justify-content: flex-end;

}


/* 170 픽셀이 이상적입니다 */
.synopsis {

  box-sizing: border-box;
  margin: 5px 20px 5px 20px; 

  height: 160px;
  font-weight: 400;

  overflow: hidden;
  
}

.author {
display:inline-block;
width: 200px;
height: 17px; 

cursor: pointer;

white-space: nowrap; 
overflow: hidden;
text-overflow: ellipsis;

} 

.translator {
display:inline-block;
width:105px;
height: 20px; 

cursor: pointer;

}

.publisher {
display:inline-block;

width: 150px;
height: 20px;

cursor: pointer;

}

.years {
display:inline-block;

width: 100px;
height: 20px; 

cursor: pointer;

}

.fob {
display:inline-block;

width: 60px;
height: 20px; 
margin-left:20px;

}

.nob {
display:inline-block;

height: 20px; 
color: #7987b4;

}

.pages {
display:inline-block;
height: 20px;
margin-left: 5px;
color: #7987b4;

}


/****************************************************************/

.bookCover {

box-sizing: border-box;
display: inline-block;
width:280px;
height:410px;
margin: 0px 5px 20px 5px;
background-color: white;

border-style: solid;
border-color: #e1e1e1;
border-width: thin; 

position: relative;

}

.bookImg {
box-sizing: border-box;
width:278px;
height:345px; /* 북스펙과 딱 맞게 하면 꿈틀거림, 왜 그런지 모르겠음!*/
position: absolute;
z-index:3;

}

.bookSpec {

box-sizing: border-box;
background-color:#eef2fe;

width:278px;
height:345px;

position: absolute;

}

.backToimg {
  display: inline-block;
  height: 40px;
  width: 40px;
  text-align: center;
  padding-top:4px;
  padding-left: 1px;
  margin-top:0;
  border-radius: 18px;


  position: absolute;
  top: 285px;
  left: 230px;

  background-color: #4e81ff;
  color: white;

  z-index:5;

}

/**************************************** */

.keywordsUnderCover { 

  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;

  width: 278px;
  height: 70px;

  padding-left:10px;
  padding-top:5px;

  background-color: white;

  border-top: thin solid #e1e1e1;


  position: absolute;
  top: 310px;
  left: 0px;

  z-index:4;
  
  
}

.titlePart{

 display: flex;
 width: 284px;
 margin-left:3px;
 margin-bottom: 2px;
 
}


.title {

  display: inline-block;

  width: 270px;

  font-size: 15px;
  font-weight: bolder;
  padding-top:2px;  

  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;

}

.keywordPart {

  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;

  height: 34px;

}

.keywordBtn {
  box-sizing: border-box;

  display:inline-flex;
  
  cursor: pointer;

  height: 20px;
  margin: 2px;
  
  padding: 2px;
  border-radius: 5px;

  font-size: 13px;

}





</style>